import type { BookerProps } from '@duda-co/booking/runtime';
import type { CommonBookerProps } from './hooks/useCommonBookerProps';

// The native atom has no class-name props; the rest of the contract matches.
export const toNativeBookerProps = (props: CommonBookerProps): BookerProps => {
    const nativeProps = { ...props } as Record<string, unknown>;
    delete nativeProps.customClassNames;
    delete nativeProps.rescheduleClassNames;
    return nativeProps as unknown as BookerProps;
};
